import { Box, Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import discord_icon from "../assets/icons/discord_icon.png";
import twitter_icon from "../assets/icons/twitter_icon.png";
import { FaTwitter, FaDiscord } from "react-icons/fa";

const Navbar = () => {
  const barProps = {
    height: "10%",
    width: "100%",
    padding: "1em",
    backgroundColor: "#16161D",
    // maxWidth: "100%",
    // position: "sticky",
    // top: 0,
  };

  const textLogo = {
    style: {
      fontFamily: "abnes",
      fontWeight: 400,
      fontSize: "0.7em",
      color: "#FFFFFF",
    },
  };

  return (
    <Box {...barProps}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />
        <Link to="" style={{ textDecoration: "none" }}>
          <Typography {...textLogo}>VORTEX SPV</Typography>
        </Link>
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="flex-end"
          height="100%"
          paddingRight="2em"
        >
          <Link to="/team" style={{ textDecoration: "none" }}>
            <Button sx={{ fontSize: "0.7em", borderRadius: "50px" }}>
              Team
            </Button>
          </Link>
          <Link to="/about" style={{ textDecoration: "none" }}>
            <Button sx={{ fontSize: "0.7em", borderRadius: "50px" }}>
              About
            </Button>
          </Link>
          <Link to="/whitepaper" style={{ textDecoration: "none" }}>
            <Button
              sx={{
                fontSize: "0.7em",
                background:
                  "linear-gradient(277.72deg, #78AFCF -2.06%, #8FDDD9 90.6%)",
                borderRadius: "50px",
                paddingX: "20px",
              }}
            >
              Whitepaper
            </Button>
          </Link>
          <Stack direction="row">
            <Button sx={{ borderRadius: "50px" }}>
              <FaDiscord />
            </Button>
            <Button sx={{ borderRadius: "50px" }}>
              <FaTwitter />
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Navbar;
